export function useAuthFooter() {
  const currentYear = new Date().getFullYear()

  return {
    currentYear,
  }
}
